<template>
  <div class="star-wrapper">
    <!-- 1. «Серая» подложка (полная звезда) -->
    <svg
      width="24"
      height="24"
      class="star-base"
      viewBox="0 0 38 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1799 0.00012207L24.9907 11.774L37.984 13.6621L28.582 22.8268L30.8015 35.7675L19.1799 29.6577L7.55841 35.7675L9.77792 22.8268L0.3759 13.6621L13.3692 11.774L19.1799 0.00012207Z"
        fill="#B9B9B9"
      />
    </svg>

    <!-- 2. Оранжевая заливка, обрезаемая clipPath-ом до нужного процента -->
    <svg
      class="star-fill"
      width="24"
      height="24"
      viewBox="0 0 38 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath :id="clipId">
          <!-- Прямоугольник, определяющий сколько «закрасить» -->
          <rect
            x="0"
            y="0"
            :width="clipWidth"
            height="36"
          />
        </clipPath>
      </defs>

      <path
        :clip-path="`url(#${clipId})`"
        fill="#ff7b00"
        d="M19.1799 0.00012207L24.9907 11.774L37.984 13.6621L28.582 22.8268L30.8015 35.7675L19.1799 29.6577L7.55841 35.7675L9.77792 22.8268L0.3759 13.6621L13.3692 11.774L19.1799 0.00012207Z"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// Описание пропсов
const props = withDefaults(
  defineProps<{
    rating: number;
    size?: number;
  }>(),
  {
    size: 24
  }
);

// Уникальный ID для clipPath, чтобы избежать конфликтов при множественных звёздах
const clipId = `clip-${Math.random().toString(36).substr(2, 9)}`;
// viewBox для SVG
// const viewBox = '0 0 24 24';

// Считаем процент заполнения (0–100), исходя из 5-балльной шкалы
const fillPercent = computed(() => (props.rating / 5) * 100);
// Для clipPath нужно знать ширину части звезды
const clipWidth = computed(() => (38 * fillPercent.value) / 100);

const sizeString = computed(() => `${props.size}px`);
</script>

<style scoped>
.star-wrapper {
  position: relative;
  display: inline-block;
  width: v-bind(sizeString);
  height: v-bind(sizeString);
}
.star-base {
  position: absolute;
  top: 0;
  left: 0;
  width: v-bind(sizeString);
  height: v-bind(sizeString);
}
.star-fill {
  position: absolute;
  top: 0;
  left: 0;
  width: v-bind(sizeString);
  height: v-bind(sizeString);
}
</style>
